import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Bannerfrom from "../components/bannerfrom";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Node.js">
                <h1>Hire Node.js Developers in USA</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol's Node.js developers build interactive web apps and
                  data-intensive programs with a robust backend that offers a
                  high-end user experience. Working with Node.js gives us an
                  edge in creating digital solutions, SaaS, and mobile apps for
                  our clients.
                </p>
                <ul>
                  <li>Create digital solutions</li>
                  <li>Robust Web Solutions</li>
                  <li>High-end User Experience</li>
                  <li>SaaS & Mobile Apps</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
